import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=5f22d725&scoped=true&"
import script from "./Manager.vue?vue&type=script&lang=ts&"
export * from "./Manager.vue?vue&type=script&lang=ts&"
import style0 from "./Manager.vue?vue&type=style&index=0&id=5f22d725&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22d725",
  null
  
)

export default component.exports